var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgermeister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 367.8 367.8",
    style: {
      enableBackground: "new 0 0 367.8 367.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 183.9,
    cy: 183.9,
    r: 181.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.9,367.8C82.5,367.8,0,285.3,0,183.9S82.5,0,183.9,0s183.9,82.5,183.9,183.9S285.3,367.8,183.9,367.8z  M183.9,4.6C85,4.6,4.6,85,4.6,183.9S85,363.3,183.9,363.3s179.4-80.5,179.4-179.4S282.8,4.6,183.9,4.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 183.9,
    cy: 183.9,
    r: 101.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.8,94c6,4,6.5,12,0.9,20.6l-12.2,18.3l-36.9-24.5l11.6-17.5c5.5-8.2,12.3-10.6,18.4-6.6 c3.6,2.4,5.5,6.7,4.5,10.8C75.3,90.9,80.6,91.1,84.8,94z M48.3,105l9,6l5.9-8.8c2.9-4.3,2.3-8.1-0.5-9.9c-2.7-1.8-5.6-0.5-8.6,3.9 L48.3,105z M78.8,101c-2.7-1.8-5.9-0.3-8.4,3.5l-7,10.5l8.7,5.8l6.8-10.2C81.9,106,81.2,102.6,78.8,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.3,57.3c7.5,10.6,5.1,21.7-5.1,28.9c-10.2,7.2-21.4,5.7-28.9-5l-14-19.9l7.6-5.4l14,19.9 c4.4,6.2,10.9,7.5,16.5,3.5c5.6-4,6.6-10.6,2.3-16.8l-14-19.9l7.6-5.4L120.3,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.3,53.1l-9.3,2.2l3.2,13.7l-9,2.1L128.1,28l19.1-4.5c10.2-2.4,19.1,1.7,21.1,10.5c1.4,6-1,11.5-5.8,15.1 l15.4,12.6l-11,2.6L153.3,53.1z M142.1,47.4l9.7-2.3c5-1.2,8.5-4.7,7.5-8.9c-1-4.1-5.7-5.8-10.7-4.6l-9.7,2.3L142.1,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.7,45.5l-4.3,24.2l-7.1-1.3l0.5-6.4c-3.9,3.8-9.5,5.6-16.7,4.3c-13.8-2.5-22-14.3-19.9-26.2 c2.5-13.8,14.9-21.3,28.3-18.9c9.8,1.8,18.5,8.4,19.4,19.9l-9.8-1.8c-1.3-6.8-6.8-9.3-10.9-10c-8.7-1.6-16,3.1-17.7,12.4 c-1.3,7.2,3.1,14.8,12.1,16.4c6.7,1.2,11.8-1.7,14.5-6.5l-13.6-2.4l1.5-8.1L232.7,45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.8,50l-5.6,8.5l18.4,12.3l-4.5,6.8l-18.4-12.3l-5.3,7.9L270,87l-4.5,6.8l-28.4-18.9L261.6,38L290,57 l-4.5,6.8L264.8,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,108.1l-5.4-7.9l-11.6,8l-5.3-7.7l36.5-25.1L320,91.6c5.9,8.6,5.4,18.4-2.1,23.5 c-5.1,3.5-11,3.3-16.1,0.1l-6.2,18.9l-6.4-9.3L294.7,108.1z M296.1,95.5l5.7,8.2c2.9,4.2,7.5,6.2,11,3.8c3.5-2.4,3.3-7.4,0.4-11.6 l-5.7-8.2L296.1,95.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.6,296.2l-5.2-7.7l20.4-13.9L55,274.9l-3.1-4.6l0,0l8.4-20.5l-20.6,14.2l-5.2-7.7L71,231.3l3.7,5.4 l-12.2,29.7l32.1-0.5l3.7,5.4L61.6,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.9,287.4l-5.6,8.5l18.5,12.2l-4.5,6.8l-18.5-12.2l-5.2,7.9l20.8,13.7l-4.5,6.8l-28.5-18.8l24.3-37 l28.5,18.8l-4.5,6.8L107.9,287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.5,299.6l-13.6,42.1l-8.9-2.8l13.6-42.1L151.5,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.8,318.4l-9.2-0.6c-0.3-4.1-2.9-6.8-8.8-7.2c-5.1-0.3-8.6,1.3-8.8,4.9c-0.2,3.2,2.1,4.7,6.5,5.9l5.4,1.4 c9,2.4,13.9,6,13.4,13.3c-0.6,8.4-8.2,13.3-19.1,12.6c-11.5-0.8-19-7.2-19.1-16.7l9.2,0.6c0.4,4.7,4.5,7.8,10.9,8.2 c5.1,0.3,8.2-1.2,8.4-4.3c0.1-2-0.9-4-5.8-5.2l-7.4-1.9c-9.1-2.3-12.8-7-12.3-13.8c0.6-8.4,8-13.4,18.5-12.7 C183.5,303.4,193.5,307,193.8,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.9,300.1l-15.1,4.7l10.8,34.4l-8.9,2.8L218,307.6l-15.1,4.7l-2.5-7.8l39-12.3L241.9,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.6,288.3l6.3,7.9l17.3-13.8l5.1,6.4l-17.3,13.8l5.9,7.4l19.4-15.5l5.1,6.4l-26.7,21.3l-27.6-34.5 l26.7-21.3l5.1,6.4L258.6,288.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.1,258.9l-4.8,8.3l12.2,7l-4.7,8l-38.3-22.2l9.8-17c5.2-9,14.3-12.7,22.2-8.2c5.3,3.1,7.7,8.5,7,14.5 l19.7-2.5l-5.6,9.8L314.1,258.9z M302.2,263l5-8.6c2.6-4.4,2.4-9.4-1.3-11.6c-3.7-2.1-8.1,0.2-10.7,4.7l-5,8.6L302.2,263z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.7,120.7c-10.8-2.7-22.9-4.3-35.8-4.3c-12.8,0-24.9,1.5-35.6,4.2l0,0c-21.6,4.7-43.2,19.6-43.2,42.3l0,0 c0,9.6,8,17.4,17.9,17.4h121.8c9.9,0,17.9-7.8,17.9-17.4l0,0C262.7,140.4,241.2,125.4,219.7,120.7z M122.2,160.8l62.4-0.1 c1.6,0,2.1,2.2,0.6,2.8l-24.9,10.6h-24.1C128.7,174.2,122.6,168.3,122.2,160.8z M245.8,160.1c0,7.8-6.3,14.1-14.1,14.1H190 l29.9-9.8c1.7-0.6,2.9-2.2,2.9-4v-4.9c0-1.4-1.1-2.5-2.5-2.5h-97.2c3.7-14.4,18.4-23.9,33-27.1l0,0c8.4-2.2,17.9-3.4,27.9-3.4 c10.1,0,19.7,1.2,28.1,3.5C229,129.8,245.8,141.9,245.8,160.1L245.8,160.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M243.3,186.8H124.7c-9.9,0-19.7,8-19.7,18c0,19.2,15.5,40.2,34.7,40.2h88.5c19.2,0,34.4-21,34.4-40.2 C262.6,194.8,253.3,186.8,243.3,186.8z M138.1,192.6h22l24.5,10.5c1.5,0.6,1,2.8-0.6,2.8h-61.7 C123.7,198.4,130.2,192.6,138.1,192.6z M245.8,209.8c0,16.2-13.1,29.3-29.3,29.3h-65c-14.9,0-27.1-11-29.1-25.3h97.8 c1.4,0,2.5-1.1,2.5-2.5v-4.9c0-1.8-1.2-3.4-2.9-4l-29.9-9.8h39.9c8.8,0,16,7.2,16,16V209.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgermeister);
export default __webpack_public_path__ + "static/media/burgermeister.5497dd2349b8f1c16d6fd1bb3ed9db7d.svg";
export { ForwardRef as ReactComponent };